// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__rdwEi","index":"styles_index__Jp0Og","content":"styles_content__Gg2hf","title":"styles_title__4WhmE","searches":"styles_searches__4uxad"};